import React from 'react'
import {Form, Input, Button, message} from 'antd'
import API from 'api'
import {useSelector} from 'react-redux'
import {IState} from 'reducers'

import {useHistory} from 'react-router-dom'

const passwordRules = [
  {
    required: true,
    message: '密码为数字，字母，下划线',
    pattern: /^[0-9a-zA-Z_]{8,}$/,
  },
]

const confirmPasswordRules = [
  ({getFieldValue}) => ({
    validator(_, value) {
      if (!value || getFieldValue('new_password') === value) {
        return Promise.resolve()
      }
      return Promise.reject(new Error('请输入相同的密码'))
    },
  }),
]

const OldPasswordFormCom = () => {
  const [editPwdWithPasswordForm] = Form.useForm()
  const user = useSelector((state: IState) => state.user)
  const history = useHistory()

  const editPassword = values => {
    values.user_id = user.user_id
    delete values.queryPassword
    API.editPassword(values).then(res => {
      if (res.code === 200) {
        message.success({
          content: '修改密码成功',
          duration: 2,
        })
        history.push('/user/info')
      } else {
        message.error({
          content: '修改密码失败',
          duration: 2,
        })
      }
    })
  }
  const cancelEditPassword = () => {
    history.push('/user/info')
  }
  return (
    <>
      <div className="user-info-wrap">
        <div className="second-title" style={{color: '#262626', marginBottom: 16}}>
          修改密码
        </div>
        <Form
          form={editPwdWithPasswordForm}
          onFinish={editPassword}
          requiredMark={false}
          colon={false}
          labelAlign="left"
        >
          <Form.Item
            name="old_password"
            rules={passwordRules}
            label="原始密码"
            className="user-password-form-item"
          >
            <Input.Password
              size="large"
              placeholder="请输入至少8位密码"
              className="user-password-form-item-input"
            />
          </Form.Item>
          <Form.Item
            name="new_password"
            rules={passwordRules}
            label="新密码"
            className="user-password-form-item"
          >
            <Input.Password
              size="large"
              placeholder="请输入至少8位密码"
              className="user-password-form-item-input"
            />
          </Form.Item>
          <Form.Item
            label="确认密码"
            name="queryPassword"
            rules={confirmPasswordRules}
            dependencies={['new_password']}
            className="user-password-form-item"
          >
            <Input.Password
              size="large"
              placeholder="请输入至少8位密码"
              className="user-password-form-item-input"
            />
          </Form.Item>
          <Form.Item>
            <div className="user-password-form-item-button-outer">
              <Button
                size="large"
                className="user-password-form-item-button"
                onClick={cancelEditPassword}
              >
                取消
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                className="user-password-form-item-button"
              >
                提交
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </>
  )
}

export default OldPasswordFormCom
